import { Trans } from '@lingui/react/macro';
import { Upload } from 'lucide-react';
import { useImportBoardTemplate } from 'modules/template-editor/ui/hooks/use-import-board-template';
import UDButton from 'ud-ui/components/button';
import UDTippy from 'ud-ui/components/tippy';

interface ImportBoardTemplateButtonProps {
  /** Организация, в которую создаётся шаблон; без неё кнопка выключена. */
  ownerId: number | undefined;
  /** Импорт создаёт шаблон — заперт там же, где «Добавить шаблон». */
  disabled: boolean;
  /** Подсказка выключенной кнопки («Не доступно в вашей подписке»). */
  lockedTooltip?: string;
}

/** «Импортировать шаблон» в шапке списка шаблонов трансляций (IMGM-1589). */
function ImportBoardTemplateButton({ ownerId, disabled, lockedTooltip }: ImportBoardTemplateButtonProps) {
  const { isImporting, pickFile, fileInput } = useImportBoardTemplate(ownerId);

  return (
    <>
      <UDTippy content={lockedTooltip} placement={'bottom'}>
        <span className="inline-flex">
          <UDButton
            variant={'dark'}
            className="flex items-center"
            onClick={pickFile}
            loading={isImporting}
            disabled={disabled || !ownerId}
          >
            <Upload size={16} className="mr-2" />
            <Trans>Импортировать шаблон</Trans>
          </UDButton>
        </span>
      </UDTippy>
      {fileInput}
    </>
  );
}

export default ImportBoardTemplateButton;
